// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel_uploader[data-v-09e45037]{display:flex;align-items:flex-start}.carousel_uploader img[data-v-09e45037]{width:100px;height:100px;border:1px dashed #d9d9d9;border-radius:6px;display:flex;justify-content:center;align-items:center}.form_input[data-v-09e45037]{width:300px}.form_name[data-v-09e45037],.link[data-v-09e45037]{margin-left:20px}.tip[data-v-09e45037]{margin-left:10px;color:#409eff}", ""]);
// Exports
module.exports = exports;
